<template>
    <div>
        <div v-if="index === 5">
            <p class="h5">
                Si votre entreprise comprend plus de 5 {{ associateNaming }}, vous serez contacté(e) par Assistel à la suite de votre souscription.
            </p>
        </div>

        <div v-else>
            <b-form-group :label="'L\'' + associateNaming + ' est une personne'" class="mb-2">
                <b-form-radio-group
                v-model="associate.type"
                buttons
                button-variant="outline-primary">
                    <b-form-radio value="Physique">Physique</b-form-radio>
                    <b-form-radio value="Morale">Morale</b-form-radio>
                </b-form-radio-group>
            </b-form-group>

            <b-form-group class="mb-1">
                <b-form-row>
                    <b-col cols="12" md="4">
                        <b-form-group label="Genre">
                            <b-form-radio-group
                            v-model="associate.sex"
                            buttons
                            button-variant="outline-primary">
                                <b-form-radio value="Féminin">Féminin</b-form-radio>
                                <b-form-radio value="Masculin">Masculin</b-form-radio>
                            </b-form-radio-group>
                        </b-form-group>
                    </b-col>

                    <b-col cols="12" md="4">
                        <b-form-group label="Prénom" label-for="associate-first-name" :invalid-feedback="'Le prénom de l\'' + associateNaming + ' est obligatoire.'">
                            <b-input
                            id="associate-first-name"
                            v-model.trim="$v.associate.name.firstName.$model"
                            :state="validateState($v.associate.name.firstName)" />
                        </b-form-group>
                    </b-col>

                    <b-col cols="12" md="4" v-if="associate.sex === 'Masculin'">
                        <b-form-group label="Nom" label-for="associate-last-name" :invalid-feedback="'Le nom de l\'' + associateNaming + ' est obligatoire.'">
                            <b-input
                            id="associate-last-name"
                            v-model.trim="$v.associate.name.lastName.$model"
                            :state="validateState($v.associate.name.lastName)" />
                        </b-form-group>
                    </b-col>

                    <b-col cols="12" md="4" v-else>
                        <b-form-group label="Nom de naissance" label-for="associate-birth-name" :invalid-feedback="'Le nom de naissance de l\'' + associateNaming + ' est obligatoire.'">
                            <b-input
                            id="associate-birth-name"
                            v-model.trim="$v.associate.name.birthName.$model"
                            :state="validateState($v.associate.name.birthName)" />
                        </b-form-group>
                    </b-col>
                </b-form-row>
            </b-form-group>

            <div v-if="associate.type === 'Physique'">
                <b-form-group>
                    <b-form-row class="mb-1">
                        <b-col cols="12" md="4">
                            <b-form-group label="Statut marital" label-for="associate-marital-status" :invalid-feedback="'Le statut marital de l\'' + associateNaming + ' est obligatoire'">
                                <b-form-select
                                id="associate-marital-status"
                                v-model="associate.maritalStatus"
                                :options="maritalGender"
                                :state="validateState($v.associate.maritalStatus)" />
                            </b-form-group>
                        </b-col>

												<b-col cols="12" md="4" v-if="associate.maritalStatus === 'Mariée' && associate.sex === 'Féminin'">
													<b-form-group label="Nom marital" label-for="associate-marital-name" :invalid-feedback="'Le nom marital de l\'' + associateNaming + ' est obligatoire.'">
														<b-input
														id="associate-marital-name"
														v-model.trim="$v.associate.name.maritalName.$model"
														:state="validateState($v.associate.name.maritalName)" />
													</b-form-group>
												</b-col>

                        <b-col cols="12" md="4" v-if="associate.maritalStatus === 'Marié'">
                            <b-form-group :label="'Marié sous la communauté de biens ?'" class="mb-1">
                                <b-form-radio-group
                                    v-model="associate.marriedUnderCommunityOfProperty"
                                    buttons
                                    button-variant="outline-primary">
                                        <b-form-radio value="true">Oui</b-form-radio>
                                        <b-form-radio value="false">Non</b-form-radio>
                                    </b-form-radio-group>
                            </b-form-group>
                        </b-col>
                    </b-form-row>
                </b-form-group>

                <b-form-group class="mb-1">
                    <b-form-row>
                        <b-col cols="12" md="3" class="mb-3">
													<b-form-group
                            label="Date de naissance"
                            label-for="associate-birthday"
                            :invalid-feedback="'La date de naissance de l\'' + associateNaming + ' est obligatoire et doit être au format jj/mm/yyyy.'">
															<b-input
															id="associate-birthday"
															v-model.trim="$v.associate.birth.day.$model"
															:state="validateState($v.associate.birth.day)"
															@input="setDate($event, index)" />
													</b-form-group>
                        </b-col>

												<b-col cols="12" md="3">
                          <b-form-group
                            label="Pays de naissance"
                            label-for="associate-birth-country"
                            :invalid-feedback="'Le pays de naissance de l\'' + associateNaming + ' est obligatoire'">
															<b-form-select
															id="associate-birth-country"
															v-model="associate.birth.country"
															:options="countriesList"
															:state="validateState($v.associate.birth.country)"
															@change="setZipCode($event, index)" />
													</b-form-group>
                        </b-col>

                        <b-col cols="12" md="3" v-if="associate.birth.country === 'France'">
                            <b-form-group
                            label="Code postal de naissance"
                            label-for="associate-birth-zipCode"
                            :invalid-feedback="'Le code postal de naissance de l\'' + associateNaming + ' est obligatoire, doit être au format numérique et comporter 5 chiffres.'">
                                <b-input
                                id="associate-birth-zipCode"
                                v-model.trim="$v.associate.birth.zipCode.$model"
                                :state="validateState($v.associate.birth.zipCode)"
                                @change="getCitiesByZipCode" />
                            </b-form-group>
                        </b-col>

                        <b-col cols="12" md="3">
                            <b-form-group label="Ville de naissance" label-for="associate-birth-city" :invalid-feedback="'Le lieu de naissance de l\'' + associateNaming + '  est obligatoire'">
                                <b-input
                                id="associate-birth-city"
                                list="citiesList"
                                v-model.trim="$v.associate.birth.city.$model"
                                :state="validateState($v.associate.birth.city)" />

                                <b-datalist id="citiesList" :options="citiesList" />
                            </b-form-group>
                        </b-col>
                    </b-form-row>
                </b-form-group>

								<b-form-row class="mb-1">
									<b-col cols="12" md="6">
										<b-form-group
										label="Nationalité"
										label-for="associate-birth-nationality"
										:invalid-feedback="'La nationalité de l\'' + associateNaming + ' est obligatoire'">
												<b-input-group prepend="🌐">
														<b-input
														id="associate-birth-nationality"
														v-model.trim="$v.associate.birth.nationality.$model"
														:state="validateState($v.associate.birth.nationality)" />
												</b-input-group>
										</b-form-group>
									</b-col>
								</b-form-row>

                <b-form-group class="mb-1">
                    <b-form-row>
                        <b-col cols="12" md="6">
                            <b-form-group label="Adresse" label-for="associate-address" :invalid-feedback="'L\'adresse de l\'' + associateNaming + ' est obligatoire'">
                                <b-input
                                id="associate-address"
                                v-model.trim="$v.associate.address.place.$model"
                                :state="validateState($v.associate.address.place)" />
                            </b-form-group>
                        </b-col>

                        <b-col cols="12" md="2">
                            <b-form-group
                            label="Code postal"
                            label-for="associate-zip-code"
                            :invalid-feedback="'Le code postal de l\'' + associateNaming + ' est obligatoire, doit être au format numérique et comporter 5 chiffres.'">
                                <b-input
                                id="associate-zip-code"
                                v-model.trim="$v.associate.address.zipCode.$model"
                                :state="validateState($v.associate.address.zipCode)"
                                @change="getCitiesByZipCode" />
                            </b-form-group>
                        </b-col>

                        <b-col cols="12" md="4">
                            <b-form-group label="Ville" label-for="associate-city" :invalid-feedback="'La ville de l\'' + associateNaming + ' est obligatoire'">
                                <b-input
                                id="associate-city"
                                list="citiesList"
                                v-model.trim="$v.associate.address.city.$model"
                                :state="validateState($v.associate.address.city)" />

                                <b-datalist id="citiesList" :options="citiesList" />
                            </b-form-group>
                        </b-col>
                    </b-form-row>
                </b-form-group>
            </div>

            <div v-else>
                <b-form-row class="mb-1">
                    <b-col cols="12" md="4">
                        <b-form-group label="Nom de la société" label-for="company-name" invalid-feedback="Le nom de la société est obligatoire">
                            <b-input
                            id="company-name"
                            v-model.trim="$v.associate.company.name.$model"
                            :state="validateState($v.associate.company.name)" />
                        </b-form-group>
                    </b-col>

                    <b-col cols="12" md="4">
                        <b-form-group label="Numéro RCS" label-for="company-rcs" invalid-feedback="Le numéro RCS est obligatoire.">
                            <b-input
                            type="number"
                            id="company-rcs"
                            v-model.trim="$v.associate.company.rcs.$model"
                            :state="validateState($v.associate.company.rcs)" />
                        </b-form-group>
                    </b-col>
                </b-form-row>

                <b-form-group label="Adresse du siège social" label-for="head-office-address" invalid-feedback="L'adresse du siège social est obligatoire.">
                    <b-input
                    id="head-office-address"
                    v-model.trim="$v.associate.company.headOffice.place.$model"
                    :state="validateState($v.associate.company.headOffice.place)" />
                </b-form-group>

                <b-form-row class="mb-1">
                    <b-col cols="12" md="4">
                        <b-form-group
                        label="Code postal"
                        label-for="head-office-zip-code"
                        invalid-feedback="Le code postal du siège social est obligatoire, doit être au format numérique et comporter 5 chiffres.">
                            <b-input
                            id="head-office-zip-code"
                            v-model.trim="$v.associate.company.headOffice.zipCode.$model"
                            :state="validateState($v.associate.company.headOffice.zipCode)"
                            @change="getCitiesByZipCode" />
                        </b-form-group>
                    </b-col>

                    <b-col cols="12" md="4">
                        <b-form-group label="Ville" label-for="head-office-city" invalid-feedback="La ville du siège social est obligatoire">
                            <b-input
                            id="head-office-city"
                            list="citiesList"
                            v-model.trim="$v.associate.company.headOffice.city.$model"
                            :state="validateState($v.associate.company.headOffice.city)" />

                            <b-datalist id="citiesList" :options="citiesList" />
                        </b-form-group>
                    </b-col>

                    <b-col cols="12" md="4">
                        <b-form-group label="Ville du Greffe" label-for="head-office-registry" invalid-feedback="La ville du Greffe du siège social est obligatoire">
                            <b-input
                            id="head-office-registry"
                            list="citiesList"
                            v-model.trim="$v.associate.company.headOffice.registry.$model"
                            :state="validateState($v.associate.company.headOffice.registry)" />

                            <b-datalist id="citiesList" :options="citiesList" />
                        </b-form-group>
                    </b-col>
                </b-form-row>

                <b-form-row class="mb-1">
                    <b-col>
                        <b-form-group
                        label="Capital social"
                        label-for="associate-company-share-capital">
                            <b-input-group>
                                <b-input
                                type="number"
                                id="associate-company-share-capital"
                                v-model.trim="$v.associate.company.shareCapital.$model"
                                aria-describedby="associate-company-share-capital-live-feedback"
                                :state="validateState($v.associate.company.shareCapital)" />

                                <div class="input-group-append">
                                    <span class="input-group-text">€</span>
                                </div>

                                <b-form-invalid-feedback id="associate-company-share-capital-live-feedback">
                                    Le capital social est oligatoire
                                </b-form-invalid-feedback>
                            </b-input-group>
                        </b-form-group>
                    </b-col>

                    <b-col>
                        <b-form-group
                        label="Forme sociale"
                        label-for="associate-company-social-form"
                        invalid-feedback="La forme sociale est obligatoire.">
                            <b-input
                            id="associate-company-social-form"
                            v-model.trim="$v.associate.company.socialForm.$model"
                            placeholder="SARL, SASU, etc..."
                            :state="validateState($v.associate.company.socialForm)" />
                        </b-form-group>
                    </b-col>
                </b-form-row>
            </div>

            <b-form-group>
								<h5>Apports</h5>

								<b-form-row>
									<b-col cols="12" md="6">
										<b-form-checkbox
										v-model="associate.contribution.numerary.active"
										button
										button-variant="primary"
										size="sd"
										class="mb-2">
											Numéraire
										</b-form-checkbox>

										<b-form-group
										v-if="associate.contribution.numerary.active"
										label="Quel est le montant de l'apport effectué ?"
										label-for="associate-contribution-amount"
										invalid-feedback="Le montant de l'apport est obligatoire."
										class="mb-4">
											<b-input-group>
												<b-input
												type="number"
												id="associate-contribution-amount"
												v-model.trim="$v.associate.contribution.numerary.amount.$model"
												:state="validateState($v.associate.contribution.numerary.amount)" />

												<div class="input-group-append">
													<span class="input-group-text">€</span>
												</div>
											</b-input-group>
										</b-form-group>
									</b-col>
								</b-form-row>

								<b-form-checkbox
								v-model="associate.contribution.inKind.active"
								button
								button-variant="primary"
								size="sd"
								class="mb-2">
									Nature
								</b-form-checkbox>

								<b-tabs justified v-if="associate.contribution.inKind.active">
									<InKindContributionTab
									v-for="(inKindContribution, index) in associate.contribution.inKind.contributions" :key="index"
									:index="index"
									@add-in-kind-contribution="addInKindContribution"
									@delete-in-kind-contribution="deleteInKindContribution"
									@update-in-kind-contribution="updateInKindContribution"
									@can-continue="canContinue" />
								</b-tabs>
            </b-form-group>
        </div>

        <b-form-row class="mt-3">
            <b-col cols="auto" v-if="index != 5">
							<b-button class="btn" @click="addAssociate">
								<span v-if="associateNaming === 'associé'">Ajouter un nouvel associé</span>
								<span v-else>Ajouter un nouvel actionnaire</span>
							</b-button>
            </b-col>

            <b-col v-if="index !== 0">
							<b-button class="btn btn-danger" @click="deleteAssociate(index)">
								<span v-if="associateNaming === 'associé'">Supprimer l'associé</span>
								<span v-else>Supprimer l'actionnaire</span>
							</b-button>
            </b-col>
        </b-form-row>
    </div>
</template>

<script>
    import { mapState } from 'vuex';

    import InKindContributionTab from './InKindContributionsTab.vue';

    import { required, numeric, minLength, maxLength } from "vuelidate/lib/validators";

    export default {
        components: {
					InKindContributionTab
        },
        props : {
            index : {
							type: Number,
							required: true
            },
            associate : {
							type: Object,
							required: true
            },
            citiesList : {
							type: Array,
							required: true
            },
						countriesList: {
							type: Array,
							required: true
						},
            associateNaming: {
							type: String,
							required: true
            }
        },
        validations() {
					let datas = {
						associate : {
							name: {
								firstName: { required }
							},
							contribution: {
								numerary: {
									amount: { required }
								}
							}
						}
					}

					if (this.associate.sex === "Masculin") {
						datas.associate.name.lastName = { required }
					} else {
						Object.assign(datas.associate.name, {
							birthName : { required },
							maritalName : { required }
						})
					}

					if (this.associate.type === "Physique") {
						Object.assign(datas.associate, {
							maritalStatus: { required },
							birth: {
								day: {
									required,
									minLength : minLength(10),
									maxLength : maxLength(10)
								},
								zipCode: {
									required,
									numeric,
									minLength : minLength(5),
									maxLength : maxLength(5)
								},
								city: { required },
								country: {required},
								nationality: { required }
							},
							address: {
								place: { required },
								zipCode: {
									required,
									numeric,
									minLength : minLength(5),
									maxLength : maxLength(5)
								},
								city: { required }
							}
						})
					} else {
						datas.associate.company = {
							name: { required },
							rcs: { required, numeric },
							headOffice: {
								place: { required },
								zipCode: {
									required,
									numeric,
									minLength : minLength(5),
									maxLength : maxLength(5)
								},
								city: { required },
								registry: { required }
							},
							shareCapital: { required },
							socialForm: { required }
						}
					}

					return datas;
        },
        watch: {
					$v: {
						handler: function (val) {
							this.$emit('update-associates');

							if (!val.$invalid) {
								this.$emit('can-continue', true);
							} else {
								this.$emit('can-continue', false);
							}
						},
						deep: true
					}
        },
        methods: {
					canContinue (value) {
						if (value === true)
							this.$emit('can-continue', true);
						else
							this.$emit('can-continue', false);
					},
					addInKindContribution () {
						this.associate.contribution.inKind.contributions.push(null);
					},
					deleteInKindContribution (index) {
						this.associate.contribution.inKind.contributions.splice(index, 1);
					},
					updateInKindContribution (index, inKindContribution) {
						this.associate.contribution.inKind.contributions[index] = inKindContribution;

						this.$emit('update-associates');
					},

					addAssociate () {
						this.$emit('add-associate');
					},
					deleteAssociate (index) {
						this.$emit('delete-associate', index);
					},
					validateState (v) {
						if (!v.$dirty) {
							return null;
						} else {
							return (v.$error) ? false : true
						}
					},
					getCitiesByZipCode (zipCode) {
						this.$emit('get-cities-by-zip-code', zipCode);
					},
					setDate (event, index) {
						if (event.length === 2 || event.length === 5) {
							this.$emit('add-birthday-slash', "associate", index);
						}
					},
					setZipCode (event, index) {
						if (event !== 'France') {
							this.$emit('add-foreign-zip-code', "associate", index);
						}
					}
        },
        computed: {
					maritalGender () {
						return (this.associate.sex === 'Masculin') ? this.maritalStatus.male : this.maritalStatus.female
					},
					...mapState(['maritalStatus']),
        },
        mounted() {
					this.associate.maritalStatus = this.maritalStatus[0];
        }
    }
</script>
